import {HTMLAttributes} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';

export function BelowTabTextLabel({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLSpanElement>) {
  return (
    <Text
      className={twMerge(
        'font-small2 text-ellipsis break-all text-theme-solid-60 line-clamp-1',
        className
      )}
      {...props}
    >
      {children}
    </Text>
  );
}

export const BelowTabTextLabelType = (<BelowTabTextLabel />).type;
